import { DAIMI_PS_INTRO, DAIMI_PS_SLUG } from '@/content/daimiPublicServices'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-sixth report with a designed page of its own, and the eleventh focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Retail cut before it (*"referans alarak ilgili sayfayı birebir tıpa
  // tıp aynısını tasarla"*) with a four-part full-page capture of the live page, the
  // cover as two overlapping 2000px crops, Figure 1 and the report mockup. See
  // `content/daimiPublicServices.ts` and `pages/DaimiPublicServices.tsx`. Not to be
  // confused with the Services cut below it, which is a separate report on
  // `'services-focus'`. It is also the cut the focus fold happened in: the five
  // pages of this shape are one component now (`pages/FocusPage.tsx`).
  ...focus(
    DAIMI_PS_SLUG,
    'Public Services',
    'daimi-report-2026-public-services-cover',
    'c019c71a-0896-493e-819b-585b4db09cd7-digitopia-daimi-2026-report-publicservices.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_PS_INTRO.body,
  layout: 'public-services-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiPublicServicesChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 14
